module.exports = __webpack_public_path__ + "img/product_51.a0d2827.webp";